import { gql } from "@apollo/client";

export const currentVisitFragment = gql`
  fragment PatientCurrentVisit on Visit {
    _id
    expiryStrategy
    admissionEvent {
      _id
      type
    }
    insuranceList {
      insurance {
        insuranceProvider {
          name
          insuranceType
          visitValidation {
            expiryStrategy
          }
        }
      }
      isValidForVisit
      visitInsuranceDetails
    }
  }
`;
